import { render, staticRenderFns } from "./FavoriteTagsForm.vue?vue&type=template&id=13cb1906&scoped=true&"
import script from "./FavoriteTagsForm.vue?vue&type=script&lang=js&"
export * from "./FavoriteTagsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cb1906",
  null
  
)

export default component.exports